module.exports = __webpack_public_path__ + "2b4f93dc26d356545b23526e83cfcb27.svg";